import { GetterTree } from 'vuex'
import { IRootState, IShoppingCartState } from '@/@types'
import CONSTANTS from '@/constants'

const {
  PLANS,
  PREMIUM_PLANS,
  EXTENSIONS,
  BLACK_FRIDAY_PRODUCT_BUNDLES,
  TCS_PROMO_PRODUCT_BUNDLES,
} = CONSTANTS
const { INE_TCS_BUNDLE } = TCS_PROMO_PRODUCT_BUNDLES

const checkIfPremiumPlusIsSelected = (state: IShoppingCartState) => {
  const selectedPlan = state?.selectedPlan as { merchant_id?: string }
  if (!selectedPlan) {
    return false
  }
  return (
    selectedPlan?.merchant_id === PLANS.PREMIUM_PLUS ||
    state?.shoppingCart.some(item => item.merchant_id === PLANS.PREMIUM_PLUS)
  )
}

const getters: GetterTree<IShoppingCartState, IRootState> = {
  selectedPlan: state => {
    const planCodesWithExceptions = Object.values(PLANS).filter(
      planId => ![PLANS.SKILL_DIVE_ANNUAL, INE_TCS_BUNDLE].includes(planId)
    )
    return (
      state.shoppingCart.find(
        item => item.merchant_id && planCodesWithExceptions.includes(item.merchant_id)
      ) || {}
    )
  },
  selectedSkillDivePlan: state => {
    const cartHasSkillDive = state.shoppingCart.find(
      item => item.merchant_id === PLANS.SKILL_DIVE_ANNUAL
    )
    return cartHasSkillDive || {}
  },
  selectedPlanCode: state => {
    const selectedPlan = state.selectedPlan as { merchant_id?: string }
    return selectedPlan.merchant_id || ''
  },
  selectedExtension: state => {
    const cartHasExtension = state.shoppingCart.find(
      item => item.merchant_id === EXTENSIONS.EXAM_EXTENSION
    )
    return cartHasExtension || {}
  },
  selectedBundle: (state, _, rootState) => {
    const fundamentalsOnCart = state.shoppingCart.find(item => item.merchant_id === PLANS.ANNUAL)
    let selectedBundle
    if (fundamentalsOnCart) {
      selectedBundle = rootState.products.availableProductBundles.find(
        item => item.slug === BLACK_FRIDAY_PRODUCT_BUNDLES.INE_BLACK_FRIDAY_BUNDLE_THREE
      )
    } else {
      selectedBundle = state.shoppingCart.find(item => item.slug)
    }
    return selectedBundle || {}
  },
  bundleProductHasError: state => {
    return state.bundleProductHasError
  },
  getShoppingCart: state => {
    return state.shoppingCart
  },
  getAddOnsCertificationsList: state => {
    return state.addOnsCertificationsList
  },
  cartHasPremiumSubscription: state => {
    return state.shoppingCart.some(item =>
      [...Object.values(PREMIUM_PLANS)].includes(item.merchant_id)
    )
  },
  cartHasFundamentalsAnnualSubscription: state => {
    return state.shoppingCart.some(item =>
      [PLANS.ANNUAL, PLANS.EJPT_FUNDAMENTALS].includes(item.merchant_id)
    )
  },
  cartHasFundamentalsMonthlySubscription: state => {
    return state.shoppingCart.some(item => item.merchant_id === PLANS.MONTHLY)
  },
  isPremiumPlusSelected(state) {
    return checkIfPremiumPlusIsSelected(state)
  },
  selectedAddOnsByUser(state) {
    return state.selectedAddOnsByUser
  },
  isPlaceOrderDisabled(state) {
    return !state.selectedAddOnsByUser && checkIfPremiumPlusIsSelected(state)
  },
  cartHasPremiumPlusSubscription: state => {
    return state.shoppingCart.some(item => item.merchant_id === PLANS.PREMIUM_PLUS)
  },
}

export default getters
